// @ts-strict-ignore
import { LMFormatterService } from '@list/formatters';
import { AppConstants } from '@app/utils';

export const lmMaskOptionsFunction = (
  lmFormatterService: LMFormatterService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView
): SohoMaskOptions => {

  if (!columnDef || columnDef.displayField.type !== AppConstants.BCD) {
    return;
  }

  // Need to keep logic in sync with setNumberFormat
  const targetDataView = lmFormatterService.listSpec.isTemplateList ? dataView.dataView : dataView;
  const precision: number = lmFormatterService.getDisplayFieldPrecision(columnDef.displayField, targetDataView);
  let allowDecimal: boolean = (columnDef.displayField.decSize !== undefined && columnDef.displayField.decSize > 0);
  let integerLimit: number = columnDef.displayField.size;
  let decimalLimit: number;

  if (allowDecimal) {
    const decSize: number = columnDef.displayField.decSize;

    // always use the smallest size for fraction
    const fractionDigits: number = (precision < decSize) ? precision : decSize;

    if (fractionDigits > 0) {
      decimalLimit = (columnDef.displayField.numberOfDecimals || columnDef.displayField.numberOfDecimals === 0) ? columnDef.displayField.numberOfDecimals : fractionDigits;
    } else {
      allowDecimal = false;
    }

    integerLimit = columnDef.displayField.size - decSize;
  }

  const maskOptions: SohoMaskOptions = {
    process: 'number',
    patternOptions: {
      allowDecimal,
      allowNegative: !columnDef.displayField.positiveOnly,
      integerLimit,
      decimalLimit,
      allowLeadingZeros: true,
      allowThousandsSeparator: false,
      symbols: {
        decimal: Soho.Locale.numbers().decimal,
        negative: Soho.Locale.numbers().minusSign,
        thousands: Soho.Locale.numbers().group
      }
    }
  };

  return maskOptions;
};
